import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  createIncoterms,
  deleteIncoterms,
  getAllActiveIncoterms,
  getAllIncoterms,
  getIncotermsByID,
  IncotermsActiveInactive,
  updateIncoterms,
} from "./services/incoterms.service";
import { IIncoterms, IIncotermsState } from "./incotermsModel";

const initialState: IIncotermsState = {
  loading: false,
  formLoading: false,
  error: "",
  IncotermsList: [],
  IncotermsID: null,
  IncotermsDetail: {
    incoterms: "",
    isactive: 1,
  },
};

const callresultSlice = createSlice({
  name: "incoterms",
  initialState,
  reducers: {
    clearIncotermsDetails: (state) => {
      state.IncotermsDetail = initialState.IncotermsDetail;
    },
    setIncotermsID: (state, action) => {
      state.IncotermsID = action.payload;
    },
    clearIncotermsID: (state) => {
      state.IncotermsID = initialState.IncotermsID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllIncoterms.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllIncoterms.fulfilled,
      (state, action: PayloadAction<IIncoterms[]>) => {
        state.loading = false;
        state.IncotermsList = action.payload || [];
      }
    );
    builder.addCase(getAllIncoterms.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.IncotermsList = [];
    });
    builder.addCase(getAllActiveIncoterms.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveIncoterms.fulfilled,
      (state, action: PayloadAction<IIncoterms[]>) => {
        state.loading = false;
        state.IncotermsList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveIncoterms.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.IncotermsList = [];
    });
    builder.addCase(createIncoterms.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createIncoterms.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createIncoterms.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateIncoterms.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateIncoterms.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateIncoterms.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteIncoterms.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteIncoterms.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteIncoterms.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(IncotermsActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(IncotermsActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(IncotermsActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getIncotermsByID.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getIncotermsByID.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.IncotermsDetail = action.payload;
    });
    builder.addCase(getIncotermsByID.rejected, (state, action) => {
      state.formLoading = false;
      state.IncotermsDetail = initialState.IncotermsDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearIncotermsDetails, setIncotermsID, clearIncotermsID } =
  callresultSlice.actions;
export default callresultSlice.reducer;
